/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Module, Node } from "@msdyn365-commerce-modules/utilities";
import * as React from "react";

import { IAddressAddUpdateProps } from "@msdyn365-commerce-modules/address";

const AddressAddUpdate: React.FC<IAddressAddUpdateProps> = (props: any) => {
  const {
    AddressForm,
    heading,
    items,
    hasError,
    error,
    isShowSaveButton,
    saveButton,
    isShowCancelButton,
    cancelButton,
    resources,
  } = props;

  return (
    <Node {...AddressForm}>
      {heading}
      {items &&
        items.map((item: any) => {
          const { AddressItem, key, label, alert, input } = item;

          if (item.key === "State") {
            if (item.input.props.displayData.length > 1) {
              <Node {...AddressItem} key={key}>
                {label}
                {input}
                {hasError && alert}
              </Node>;
            } else {
              input.props.displayData.push({
                key: "No state",
                value: "No state",
              });

              return (
                <Node {...AddressItem} key={key}>
                  {label}
                  {input}
                  {hasError && alert}
                </Node>
              );
            }
          }

          if (item.key === "Phone") {
            return (
              <Node {...AddressItem} key={key}>
                {label}
                {input}
                <span
                  className="msc-address-form__alert"
                  id="addressPhone"
                  style={{ display: "none" }}
                >
                  {resources.requiredFieldMissingError}
                </span>
                {hasError && alert}
              </Node>
            );
          }
          return (
            <Node {...AddressItem} key={key}>
              {label}
              {input}
              {hasError && alert}
            </Node>
          );
        })}
      {hasError && (
        <Node {...error.AddressError}>
          {error.title}
          {error.message}
        </Node>
      )}
      {isShowSaveButton && saveButton}
      {isShowCancelButton && cancelButton}
    </Node>
  );
};

const BusinessAccountAddressView: React.FC<any> = (props) => {
  const { BusinessAccountAddress, showAddOrUpdateAddress, resources } = props;
  const zipCode: any =
    typeof document != "undefined"
      ? document.querySelector("#company_addresszipcode")
      : null;
  if (zipCode) {
    zipCode.setAttribute("type", "text");
  }
  const phone: any =
    typeof document != "undefined"
      ? document.querySelector("#company_addressphone")
      : null;
  if (phone) {
    phone?.setAttribute("type", "tel");
    phone?.setAttribute("pattern", "[d+ ]*$");
  }

  return (
    <Module {...BusinessAccountAddress}>
      <AddressAddUpdate {...showAddOrUpdateAddress} resources={resources} />
    </Module>
  );
};

export default BusinessAccountAddressView;
